import React, { useState } from "react";
import { Text, TouchableOpacity, StyleSheet, FlatList } from "react-native";
import { Input } from "react-native-elements";

const TablePracticeScreen = () => {
  const [table, setTable] = useState("");
  const [t, setT] = useState([]);

  const array = [];

  const onChange = () => {
    for (let i = 1; i <= 10; i++) {
      var ans = parseInt(table) * i;
      var str = table + "X" + i + "=" + ans;
      array.push(str);
      setT(array);
    }
    // console.log(array);
    setTable("");
  };

  return (
    <>
      <Input
        keyboardType={"number-pad"}
        label="Enter Digit"
        value={table}
        onChangeText={(newValue) => setTable(newValue)}
      />
      <TouchableOpacity style={styles.button} onPress={onChange}>
        <Text>Practice</Text>
      </TouchableOpacity>

      <FlatList
        data={t}
        renderItem={({ item, index }) => {
          return <Text style={styles.text}>{item}</Text>;
        }}
        keyExtractor={(item, index) => index.toString()}
      />
    </>
  );
};

const styles = StyleSheet.create({
  button: {
    alignItems: "center",
    borderColor: "black",
    borderWidth: 2,
    borderRadius: 180,
    padding: 10,
    margin: 10,
  },
  text: {
    textAlign: "center",
    fontSize: 30,
  },
});

export default TablePracticeScreen;
